// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oa-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
}

.oa-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.oa-box {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
}

.oa-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.oa-box-title {
  font-weight: 700;
  color: #444;
}

.oa-link {
  color: #167ac6;
  background: none;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.oa-readable { line-height: 1.55; }
.oa-blue { color: #154fe6; font-weight: 700; }
.oa-map {
  color: #167ac6;
  text-decoration: underline;
  word-break: break-all;
  display: block;
  margin-top: 6px;
}

.oa-row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

.oa-label { font-weight: 700; color: #444; }
.oa-hint { color: #6b7280; font-weight: 600; }

.oa-input, .oa-select {
  width: 100%;
  min-height: 44px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  outline: none;
  box-sizing: border-box;
}
.oa-input:focus, .oa-select:focus { border-color: #167ac6; }

.oa-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}

.oa-btn {
  background: #22c55e;
  border: 1px solid #16a34a;
  color: #fff;
  border-radius: 8px;
  padding: 8px 14px;
  font-weight: 700;
  cursor: pointer;
}
.oa-btn:disabled { opacity: .6; cursor: not-allowed; }

/* Mobile: stack pickup/dropoff vertically */
@media (max-width: 768px) {
  .oa-grid {
    grid-template-columns: 1fr;
  }

  .oa-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .oa-label {
    margin-bottom: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/orders/css/order-addresses.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe,iBAAiB,EAAE;AAClC,WAAW,cAAc,EAAE,gBAAgB,EAAE;AAC7C;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,YAAY,gBAAgB,EAAE,WAAW,EAAE;AAC3C,WAAW,cAAc,EAAE,gBAAgB,EAAE;;AAE7C;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA,mBAAmB,WAAW,EAAE,mBAAmB,EAAE;;AAErD,4CAA4C;AAC5C;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".oa-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 20px;\n}\n\n.oa-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.oa-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.oa-box-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.oa-box-title {\n  font-weight: 700;\n  color: #444;\n}\n\n.oa-link {\n  color: #167ac6;\n  background: none;\n  border: none;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.oa-readable { line-height: 1.55; }\n.oa-blue { color: #154fe6; font-weight: 700; }\n.oa-map {\n  color: #167ac6;\n  text-decoration: underline;\n  word-break: break-all;\n  display: block;\n  margin-top: 6px;\n}\n\n.oa-row {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.oa-label { font-weight: 700; color: #444; }\n.oa-hint { color: #6b7280; font-weight: 600; }\n\n.oa-input, .oa-select {\n  width: 100%;\n  min-height: 44px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 12px;\n  outline: none;\n  box-sizing: border-box;\n}\n.oa-input:focus, .oa-select:focus { border-color: #167ac6; }\n\n.oa-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 6px;\n}\n\n.oa-btn {\n  background: #22c55e;\n  border: 1px solid #16a34a;\n  color: #fff;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.oa-btn:disabled { opacity: .6; cursor: not-allowed; }\n\n/* Mobile: stack pickup/dropoff vertically */\n@media (max-width: 768px) {\n  .oa-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .oa-row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n\n  .oa-label {\n    margin-bottom: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
